import React, { Component } from 'react'
import { OrdinalFrame } from 'semiotic'
import * as moment from 'moment'
import { withStyles } from 'material-ui/styles'
import { Typography } from 'material-ui'

const styles = theme => ({
  divAlign: {
    marginLeft: -theme.spacing.unit * 6,
    width: window.innerWidth
  },
  divChartBurnDown: {
    position: 'absolute',
    marginLeft: theme.spacing.unit * 5
  },
  divTextTitle: {
    marginTop: '5px',
    marginLeft: theme.spacing.unit * 3
  },
  display1: {
    color: 'grey',
    textAlign: 'left',
    marginLeft: '30px'
  },
  textStatus: {
    fontSize: 12,
    color: 'lightgrey',
    textAlign: 'left',
    paddingLeft: '30px',
    marginTop: '5px',
    marginBottom: '5px'
  }
})

const generate = (n, x) => {
  var arr = []
  for (var i = 0; i < n; i++) {
    arr.push(i * x)
  }
  return arr
}

const axis = total => ({
  orient: 'left',
  tickFormat: d => (
    <text
      key={`tick-${d}`}
      style={{ fill: '#cecece', textAnchor: 'end', fontSize: 10 }}
      y={-2}
    >
      {d}
    </text>
  ),
  tickValues: total > 20 ? generate(100, 20) : generate(20, 1),
  baseline: false,
  tickLineGenerator: ({ xy }) => (
    <path
      key={`tickLine-${xy.value}`}
      style={{ stroke: '#F0F0F0 ' }}
      d={`M${xy.x1},${xy.y1}L${xy.x2},${xy.y1}L${xy.x2},${xy.y1}L${xy.x1},${
        xy.y1
      }Z`}
    />
  )
})

const axisProj = total => ({
  orient: 'left',
  tickFormat: d => (
    <text
      key={`tick-${d}`}
      style={{
        fill:
          total / 60 < 17
            ? '#cecece'
            : d % 480 === 0
              ? '#cecece'
              : total / 60 > 20 ? 'rgba(0,0,0,0)' : '#F8F8F8',
        textAnchor: 'end',
        fontSize: 10
      }}
      y={-2}
    >
      {parseInt(d / 60, 10)}
    </text>
  ),
  tickValues: total / 60 > 100 ? generate(500, 480) : generate(500, 60),
  baseline: false,
  tickLineGenerator: ({ xy }) => (
    <path
      key={`tickLine-${xy.value}`}
      style={{
        stroke:
          total / 60 < 17
            ? '#F0F0F0 '
            : xy.value % 480 === 0
              ? '#F0F0F0 '
              : total / 60 > 60 ? 'rgba(0,0,0,0)' : '#FCFCFC'
      }}
      d={`M${xy.x1},${xy.y1}L${xy.x2},${xy.y1}L${xy.x2},${xy.y1}L${xy.x1},${
        xy.y1
      }Z`}
    />
  )
})

@withStyles(styles)
export default class AlchemyReadingCurrentBookBurnDown extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  timeline = ({ data, rScale, adjustedSize, margin }) => {
    const renderedPieces = []
    const keys = Object.keys(data)

    keys.forEach(key => {
      //Only one piece of data per column though we'll render multiple graphical elements
      const column = data[key]

      const widthBar = 20

      //You can return an array of graphics or an array of objects with extra data (see the Waterfall chart demo)
      const markObject = (
        <g key={`piece-${key}`}>
          {column.pieceData.map(
            (piece, index) =>
              piece.data.pageEnd > 0 && (
                <g
                  key={`g-${index}-${key}`}
                  cursor={
                    moment(new Date(piece.data.date)).isAfter(moment(), 'day')
                      ? 'auto'
                      : 'pointer'
                  }
                  onClick={
                    moment(new Date(piece.data.date)).isAfter(
                      moment(),
                      'day'
                    ) || this.props.action === ''
                      ? () => {
                          console.log('action to add')
                        }
                      : () => {
                          this.props.action(piece.data.date, 'other')
                        }
                  }
                >
                  <rect
                    key={`rect-${index}-${key}`}
                    fill={
                      piece.data.comment === 'prediction'
                        ? 'rgba(0, 0, 0, 0)'
                        : 'lightgreen'
                    }
                    stroke={
                      piece.data.comment === 'prediction'
                        ? 'lightblue'
                        : 'rgba(0, 0, 0, 0)'
                    }
                    opacity={0.5}
                    width={
                      column.width < widthBar
                        ? `${85 / keys.length}%`
                        : column.width
                    }
                    height={
                      this.props.type === 'projectTracker'
                        ? rScale(piece.data.pageEnd - piece.data.pageStart)
                        : rScale(piece.data.pages)
                    }
                    x={column.x - 8}
                    y={
                      rScale(this.props.totalPages) - rScale(piece.data.pageEnd)
                    }
                    rx={3}
                    ry={3}
                  />
                  {keys.length < 30 && (
                    <text
                      key={`text-pageEnd-${key}`}
                      x={
                        column.x + column.width / 1.3 - adjustedSize[0] / 22 + 4
                      }
                      y={
                        rScale(this.props.totalPages) -
                        rScale(piece.data.pageEnd) +
                        adjustedSize[0] / 28
                      }
                      fontSize={adjustedSize[0] / 28}
                      fontWeight={300}
                      fill={'white'}
                    >
                      {piece.data.pages}
                    </text>
                  )}
                </g>
              )
          )}
          }
        </g>
      )

      renderedPieces.push(markObject)
    })
    return renderedPieces
  }

  render() {
    if (this.props.data && this.props.data.loading) {
      return <div>Loading</div>
    }

    if (this.props.data && this.props.data.error) {
      return <div>Error</div>
    }

    const { classes } = this.props
    const tmp = this.props.data
    var predDays = 0

    var tPages = parseInt(this.props.totalPages, 10)
    var currentPage =
      this.props.type === 'projectTracker'
        ? this.props.maxPage
        : parseInt(tmp[tmp.length - 1].pageEnd, 10)

    let counts = {}
    tmp.forEach(e => (counts[e.date] = 1 + (counts[e.date] || 0)))
    var readDays = Object.keys(counts).length

    var isComplete = false

    if (tPages > 0 && tPages > currentPage) {
      if (this.props.goal) {
        if (parseInt(this.props.maxPage, 10) <= tPages) {
          if (this.props.type === 'projectTracker') {
            for (
              var j = currentPage;
              j >= 0;
              j -= this.props.goal.pagesGoalHigh
            ) {
              tmp.splice(tmp.length, 0, {
                date: moment()
                  .add(predDays, 'day')
                  .format('l'),
                pages:
                  predDays === 0
                    ? this.props.goal.pagesGoalHigh > this.props.todayMins
                      ? this.props.goal.pagesGoalHigh - this.props.todayMins
                      : this.props.todayMins
                    : this.props.goal.pagesGoalHigh,
                pageStart:
                  j - this.props.goal.pagesGoalHigh <= 0
                    ? 0
                    : j - this.props.goal.pagesGoalHigh,
                pageEnd: j,
                comment: 'prediction'
              })
              predDays += 1
            }
          } else {
            for (
              var i = 0;
              i < tPages - currentPage;
              i += this.props.goal.pagesGoalHigh
            ) {
              tmp.splice(tmp.length, 0, {
                date: moment()
                  .add(i / this.props.goal.pagesGoalHigh + 1, 'day')
                  .format('l'),
                pages: this.props.goal.pagesGoalHigh,
                pageStart: parseInt(tmp[tmp.length - 1].pageEnd, 10),
                pageEnd:
                  parseInt(tmp[tmp.length - 1].pageEnd, 10) +
                  this.props.goal.pagesGoalHigh,
                comment: 'prediction'
              })
              predDays += 1
            }
            tmp[tmp.length - 1].pageEnd = this.props.totalPages
            tmp[tmp.length - 1].pages =
              this.props.totalPages - tmp[tmp.length - 2].pageEnd
          }
        }
      } else if (readDays < 7) {
        for (j = 0; j < 7 - readDays; j++) {
          tmp.splice(tmp.length, 0, {
            date: moment()
              .add(i + 1, 'day')
              .format('l'),
            pages: 0,
            pageStart: 0,
            pageEnd: 0,
            comment: 'empty'
          })
        }
      }
    } else {
      isComplete = true
    }

    if (tPages > 0 && currentPage === 0) {
      isComplete = true
    }

    return (
      <div className={classes.divAlign}>
        <div className={classes.divTextTitle}>
          {isComplete ? (
            <div>
              <Typography variant="subheading" className={classes.display1}>
                You've completed this{' '}
                {this.props.type === 'projectTracker' ? 'project' : 'book'}
              </Typography>
              <Typography variant="body1" className={classes.textStatus}>
                {readDays} days (starting from{' '}
                {moment(new Date(tmp[0].date)).format('M/D')} to{' '}
                {moment(new Date(tmp[tmp.length - 1].date)).format('M/D')} )
              </Typography>
            </div>
          ) : (
            <div>
              <Typography variant="subheading" className={classes.display1}>
                You've{' '}
                {this.props.type === 'projectTracker' ? 'worked' : 'read'}{' '}
                {readDays} {readDays > 1 ? 'days' : 'day'} so far{' '}
                <span style={{ color: 'lightgrey', fontSize: 11 }}>
                  (started from {moment(new Date(tmp[0].date)).format('M/D')})
                </span>
              </Typography>
              <Typography variant="body1" className={classes.textStatus}>
                Continue {predDays} more days to complete by{' '}
                {moment(new Date(tmp[tmp.length - 1].date)).format('M/D')}{' '}
                <br />
                <span style={{ color: 'lightgrey', fontSize: 11 }}>
                  {this.props.type === 'projectTracker'
                    ? '(Assuming you work 4 hours per day)'
                    : '(Assuming you read 20 pages per day)'}
                </span>
              </Typography>
            </div>
          )}
        </div>
        <div
          id="daily_sleep_chart_view"
          style={{
            position: 'relative',
            textAlign: 'center',
            width: this.props.width,
            height: this.props.height
          }}
        >
          <div className={classes.divChartBurnDown}>
            <OrdinalFrame
              size={[this.props.width / 1.1, this.props.height]}
              data={tmp}
              rAccessor={d => d.pageEnd}
              oAccessor={d => moment(new Date(d.date)).format('YYYY/MM/DD')}
              sortO={(a, b) => a > b}
              rExtent={[0, this.props.totalPages]}
              type={{
                type: this.timeline,
                rotate: 180
              }}
              projection="vertical"
              oPadding={this.props.width / 35}
              axis={
                this.props.type === 'projectTracker'
                  ? axisProj(this.props.totalPages)
                  : axis(this.props.totalPages)
              }
              margin={{
                left: this.props.width / 10,
                top: this.props.height / 60,
                right: this.props.width / 10,
                bottom: this.props.height / 9.6
              }}
              oLabel={d => (
                <text
                  key={`label-${d}`}
                  fill="#cecece"
                  textAnchor="middle"
                  fontSize={10}
                  x={-2}
                >
                  {tmp.length < 30
                    ? moment(new Date(d)).date() !== 1
                      ? moment(new Date(d)).format('D')
                      : moment(new Date(d)).format('M.D')
                    : moment(new Date(d)).day() === 0 &&
                      moment(new Date(d)).format('M/D')}
                </text>
              )}
              hoverAnnotation={false}
            />
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ChartTypes/AlchemyReadingCurrentBookBurnDown.js